import { Component, OnInit,ViewChildren,QueryList, ViewChild, ViewEncapsulation} from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIEntityService } from '../../_services/entity/API-entity';
import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';
import { APIHeaderService } from '../../_services/header/API-header';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatDate } from '@angular/common';
import { map } from 'rxjs/operators';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);


@Component({
  selector: 'app-consent-template-bulk-upload-summary',
  templateUrl: './consent-template-bulk-upload-summary.component.html',
  styleUrls: ['./consent-template-bulk-upload-summary.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ConsentTemplateBulkUploadSummaryComponent implements OnInit{

  filterData: any;
  form1: any = {};
  maxDate: Date = new Date();

  noRecord: any;
  onSelectdropdown: boolean = true;
  dataSource: MatTableDataSource<any>;
  entityId:any;
  // enddateError1=true;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();  
  @ViewChild('tSort') tSort: MatSort;
                   
  dataSubject = new BehaviorSubject<any[]>([]);  
   mindate= new Date(now.getFullYear(),0,1);
   maxdate = new Date(now.getFullYear(),now.getMonth(),now.getDate())

  displayedColumns: string[] = [
    'BatchId',
    'createdAt',
    'File_Name',
    'Input_Count',
    'Status',
    'Success_Count',
    'Failure_Count',
    'Exported_File'];

  constructor(
    private fb: FormBuilder,
    private es: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService


  ) { }

  ngOnInit() {
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID) || '';

    this.getBulkUploadSummaryAll( this.entityId);
    this.maxDate.setDate(new Date().getDate());

  }

  getBulkUploadSummaryAll(pid) {
    this.es.getCSBulkUploadSummary(pid).subscribe(result => {
      console.log("new data " + result);
      this.onChangeDataSource(result);
    })
  }


  onChangeDataSource(value) {
    console.log("values" + value);
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.tSort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

  onSubmitFilter(filterForm, form) {
    if (!form.valid) {
      return true;
    }
    let fdate, ldate;
    
    if (filterForm.startDate) {
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    }
    // if(this.enddateError1 && filterForm.startDate){
    //   this.enddateError=true;
    //   return true;
    // }
    if (filterForm.endDate) {
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    }
    if(filterForm.startDate && !filterForm.endDate){
      ldate=formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
      
    }

    let BatchID = filterForm.BatchId;
    let data = {
      "BatchId": BatchID,
      "Start_Date": fdate,
      "End_Date": ldate,
      'EntityID':this.entityId

    }


    this.getAllBulkUploadSummaryFilter(data);


    // Here we have call the funtion to retrieve data and change datasource
  }

  getAllBulkUploadSummaryFilter(data) {
    this.es.getAllCSBulkUploadSummaryFilter(data)
      .subscribe(r => {
        this.filterData = r;
        this.onChangeDataSource(this.filterData);
        console.log("12345 :", this.filterData);
      })

  }


  // enddateError = false
  // addEvent(event: MatDatepickerInputEvent<Date>) {
  //   if (event.value) {
  //     this.enddateError = true;
  //   }
  // }
  // addEventEnddate(event: MatDatepickerInputEvent<Date>) {
  //   if(event.value){
  //    this.enddateError1=false;
  //    this.enddateError=false;
  //   }
  // }
  reset() {
    this.getBulkUploadSummaryAll(this.entityId);
    console.log("first reset function");
   // this.enddateError = false;
  }

  downloadFailureFile(Id){     
    let data;  
  
   //let BatchID = this.form1.BatchId;
    // let TemplateName=this.form1.searchBy;
     data={
      "BatchId": Id
    }
    var fileName;
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
    
    this.es.downloadCSBulkUploadSummarysvfile(data).subscribe(r => {  
      fileName = currentdat+ 'Bulk Upload Summary Records.csv';
     
    importedSaveAs(r, fileName)
    //  this.downloadFile(r, Batch_Id);     
      this.$modal.successModal({
        title: 'Consent Template Bulk Upload Summary',
        msg: 'File has been downloaded Successfully'
      });   
    })
  }  
}


